import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ExpansionPanelComponent } from './expansion-panel.component';

@Component({
  selector: 'app-accordion',
  template: '<ng-content></ng-content>',
  styleUrls: ['./expansion.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-accordion' },
})
export class AccordionComponent {
  @Input() multi = false;

  private readonly panels = new Set<ExpansionPanelComponent>();

  register(panel: ExpansionPanelComponent): void {
    this.panels.add(panel);
  }

  unregister(panel: ExpansionPanelComponent): void {
    this.panels.delete(panel);
  }

  onPanelOpened(opened: ExpansionPanelComponent): void {
    if (this.multi) {
      return;
    }
    this.panels.forEach((panel) => {
      if (panel !== opened && panel.expanded) {
        panel.setExpanded(false);
      }
    });
  }
}
